<template>
  <div class="d-flex flex-column weapon-card" :id="weapon.weapon_name" @click="onSelect(weapon)">
    <div>
      <img :src="weapon.image" class="weapon-img w-100 h-auto mx-auto my-3" loading="lazy" :alt="weapon.paint_name">
      <!-- <p class="m-0 text-light weapon-skin-title mx-auto text-center">{{ weapon.paint_name }}</p> -->
    </div>

    <div class="weapon-overlay">
      <div class="select-icon">
        ✔️
      </div>
    </div>

    <div v-if="debug">{{ weapon }}</div>
  </div>
</template>

<script>
import lang from '@/lang/en.json'
export default {
  name: 'SkinItem',
  props: {
    weapon: {
      type: Object,
      required: true
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    langObject() {
      return lang;
    }
  },
  methods: {
    knifeSkins(weaponName) {
      console.log(weaponName)
      this.$emit('knifeSkins', weaponName)
    },
    onSelect(weapon) {
      this.$emit('onSelect', weapon)
      console.log('onSelect', weapon)
    }
  }
}
</script>

<style lang="scss" scoped>
.weapon-card {
  position: relative;
  overflow: hidden;
  padding: 1rem;
  border-radius: 1rem;
  background-color: #222;
  border: 1px solid #333;
  margin-bottom: 1rem;
  cursor: pointer;

  .weapon-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 1rem;
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;

    .select-icon {
      font-size: 2rem;
      // font-weight: bold;
    }
  }

  &:hover {
    .weapon-overlay {
      opacity: 1;
    }
  }
}
</style>